export default __webpack_public_path__ + "static/media/arrow-down-lg.1acf1c06.svg";